import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import { VERIFY_EMAIL_OTP, SEND_MOBILE, SEND_EMAIL, UPDATE_NEW_EMAIL } from "./actionTypes"
import {
  verifyEmailOtpSuccessful,
  verifyEmailOtpFailed,
  sendEmailSuccessful,
  sendEmailFailed,
  updateNewEmailSuccess,
  updateNewEmailFailed,
} from "./action"
import { verifyEmailOTPAPI, sendEmailOTPAPI, updateNewEmailAPI } from "./api"

function* sendEmailAsync(payload) {
  console.log("varifying email id saga")
  try {
    console.log("Trying to varifying email id (within try block)")
    const response = yield call(sendEmailOTPAPI, payload)
    if (response.status === 200) {
      yield put(sendEmailSuccessful())
      console.log("No Erros")
    } else {
      throw new Error(response)
    }

  } catch (error) {
    console.log("There was an error send Email Address: ", error.message)
    yield put(sendEmailFailed(error.response))
  }
}

export function* sendEmail() {
  yield takeEvery(SEND_EMAIL, sendEmailAsync)
}

function* verifyEmailOtpAsync(payload) {
  console.log("varifying OTP saga")
  try {
    console.log("Trying to varifying OTP (within try block)")
    const response = yield call(verifyEmailOTPAPI, payload)
    if (response.status === 200) {
      yield put(verifyEmailOtpSuccessful(response.data))
    } else {
      throw new Error(response);
    }
  } catch (error) {
    console.log("There was an error send Email ID: ", error.message)
    yield put(sendEmailFailed(error.response))
  }
}

export function* verifyEmailOtp() {
  yield takeEvery(VERIFY_EMAIL_OTP, verifyEmailOtpAsync)
}


function* updateNewEmailAsync(action) {
  try {
    const response = yield call(updateNewEmailAPI, action.payload)
    if (response.status === 200) {
      yield put(updateNewEmailSuccess(response?.data?.data?.message||"Email Address Updated Successfully"))
    } else {
      throw new Error(response);
    }
  } catch (error) {
    yield put(updateNewEmailFailed(error?.response?.data?.data?.message || "Something unexpected error occured, Please try again"))
  }
}

export function* updateNewEmail() {
  yield takeEvery(UPDATE_NEW_EMAIL, updateNewEmailAsync)
}

function* verifyEmailOtpSaga() {
  yield all([
    fork(sendEmail),
    fork(verifyEmailOtp),
    fork(updateNewEmail)
  ])
}

export default verifyEmailOtpSaga